import { useEffect } from "react";


export const useAsyncEffect = (fn: () => Promise<void>, dependencies?: Array<any>) => {
  // Don't use it, its error prone because static verification doesn't work
  return useEffect(() => {
    fn().then().catch(console.error);
  }, dependencies);
}